import { EProcessTypes } from 'pages/LegalEntitiesPage/helpers';
import { IPaginator } from './paginator';
import { LETypes } from 'constants/LegalEntityTypes';

export interface ILicenceTemplateResponse {
  uniqueId: string;
  statusUniqueId: string;
  general: IGeneralResponse;
  owner: IOwner;
  conditions: IConditionsResponse;
  printoutSettings: IPrintoutSettings;
  version: string;
}
export interface ILicenceTemplateApplicationProcessResponse {
  uniqueId: string;
  licenceTemplateUniqueId?: string;
  applicationProcessId: string;
  processTypeUniqueId: string;
  legalEntityType: string;
  statusUniqueId: string;
  comment: string;
  priceName: string;
  priceFee: string;
  priceDescription: string;
  version: string;
}
export interface IProcessTypes {
  uniqueId: string;
  name: string;
}
export interface ILicenceTemplateProcessTypes {
  processTypes: IProcessTypes[];
}
export interface IGeneralResponse {
  name: string;
  description: string;
  renewalFee?: number;
  varyFee?: number;
  code: string;
  licenceDurationYears: number;
  licenceDurationMonths: number;
  licenceDurationDays: number;
  licenceDurationUnlimited: boolean;
}
export interface IConditionsResponse {
  goodReason: string | null;
  goodReasonDictionaryIds: string[];
  specificCountryArea: boolean;
  competency: boolean;
  hasSafeStorage: boolean | null;
  safeStorage: string | null;
  weaponCategory: boolean;
  weaponNumberLimit: boolean;
  carryConditions: boolean;
  additionalConditions: boolean;
}
export interface ILicencesTemplateResponseContent {
  uniqueId: string;
  statusUniqueId: string;
  name: string;
  code: string;
  hasApplicationPrice: string;
  legalTypes: string[];
  createdDate: string;
  publishedApplicationForm: string;
  licenceDurationYears: string;
  licenceDurationMonths: string;
  licenceDurationDays: string;
  licenceDurationUnlimited: boolean;
}
export interface ILicencesTemplateResponse extends IPaginator {
  content: ILicencesTemplateResponseContent[];
}
export interface IObject {
  [key: string]: boolean;
}

export interface IGeneral {
  name: string;
  description: string;
  code: string;
  licenceDurationYears: number;
  licenceDurationMonths: number;
  licenceDurationDays: number;
  licenceDurationUnlimited: boolean;
}
export enum EgoodReasonValues {
  Dictionary = 'DICTIONARY',
  Text = 'STRING',
}
export enum EsafeStorageValues {
  Object = 'OBJECT',
  Text = 'STRING',
}

export interface ISafeStorage {
  uniqueId: string;
  typeUniqueId: string;
  line1: string;
  line2: string;
  city: string;
  postalCode: string;
  regionUniqueId: string;
  countryUniqueId: string;
  latitude: number;
  longitude: number;
  storage: boolean;
  isDefault: boolean;
  firearmAmount: string;
  ancilliaryAmount: string;
}
export interface ILicenceSafeStorage {
  addressUniqueId: string;
  typeUniqueId: string;
  line1: string;
  line2: string;
  city: string;
  postalCode: string;
  regionUniqueId: string;
  countryUniqueId: string;
  latitude: string | number;
  longitude: string | number;
  storage: boolean;
  isDefault: boolean;
}
export interface IConditions {
  goodReason: string | null;
  goodReasonDictionaryIds: IObject;
  specificCountryArea: boolean;
  competency: boolean;
  safeStorage: string | null;
  weaponCategory: boolean;
  weaponNumberLimit: boolean;
  carryConditions: boolean;
  additionalConditions: boolean;
}
export interface IConditionsRequest {
  goodReason: string | null;
  goodReasonDictionaryIds: string[];
  specificCountryArea: boolean;
  competency: boolean;
  safeStorage: string | null;
  weaponCategory: boolean;
  weaponNumberLimit: boolean;
  carryConditions: boolean;
  additionalConditions: boolean;
}
export interface IDocumentInformation {
  licenceName: boolean;
  licenceNumber: boolean;
  validityPeriod: boolean;
  licenceCategory: boolean;
  carryConditions: boolean;
  region: boolean;
  goodReason: boolean;
  competency: boolean;
  weaponNumberLimit: boolean;
  licencingAuthority: boolean;
  licencingAuthoritySignature: boolean;
  additionalConditions: boolean;
  legalEntityIndividualId: boolean;
  legalEntityOrganisationId: boolean;
  organisationPrimaryAddress: boolean;
  individualPrimaryAddress: boolean;
  organisationName: boolean;
  organisationType: boolean;
  departmentName: boolean;
  fullName: boolean;
  dateOfBirth: boolean;
  placeOfBirth: boolean;
  nationality: boolean;
  gender: boolean;
  photo: boolean;
  height: boolean;
  occupation: boolean;
  urn: boolean;
  type: boolean;
  make: boolean;
  model: boolean;
  calibre: boolean;
  serialNumber: boolean;
  weaponCategory: boolean;
  action: boolean;
}

export interface IPrintoutSettingsGeneral {
  licenceName: boolean;
  licenceCode: boolean;
  licenceNumber: boolean;
  licencePeriod: boolean;
  issueDate: boolean;
  issuedLicencingAuthorityName: boolean;
  issuedLicencingAuthorityPerson: boolean;
  issuedLicencingAuthoritySignature: boolean;
}
export interface IPrintoutSettingsConditions {
  areaRestriction: boolean;
  competency: boolean;
  safeStorage: boolean;
  weaponCategorisation: boolean;
  weaponNumberLimit: boolean;
  carryConditions: boolean;
  statutoryAndAdditionalConditions: boolean;
  goodReasons: boolean;
}
export interface IPrintoutSettingsOwner {
  legalType: boolean;
  fullName: boolean;
  primaryAddress: boolean;
  gender: boolean;
  documentTypeAndName: boolean;
  dateOfBirth: boolean;
  placeOfBirth: boolean;
  nationality: boolean;
  height: boolean;
  occupation: boolean;
  photo: boolean;
  secondSurname: boolean;
  organisationType: boolean;
  organisationName: boolean;
  departmentName: boolean;
}
export interface IPrintoutSettingsWeaponData {
  type: boolean;
  make: boolean;
  model: boolean;
  calibre: boolean;
  action: boolean;
  manufacturer: boolean;
  serialNumber: boolean;
}

export interface IPrintoutSettings {
  general: IPrintoutSettingsGeneral;
  conditions: IPrintoutSettingsConditions;
  licenceOwner: IPrintoutSettingsOwner;
  weaponData: IPrintoutSettingsWeaponData;
}

export interface ILicenceTemplateFormValues {
  published?: boolean;
  general: IGeneral;
  owner: IOwnerResponse;
  conditions: IConditions;
  documentInformation?: IDocumentInformation;
}

export interface IGeneralRequest {
  name: string;
  code: string;
  licenceDurationYears: number;
  licenceDurationMonths: number;
  licenceDurationDays: number;
  licenceDurationUnlimited: boolean;
  description: string;
}
export interface IOwner {
  legalTypes: string[];
  individual: IOwnerIndividual;
  organisation: IOwnerOrganisation;
}
export interface IOwnerIndividual {
  legalEntityId: boolean;
  fullName: boolean;
  primaryAddress: boolean;
  dateOfBirth: boolean;
  placeOfBirth: boolean;
  nationality: boolean;
  height: boolean;
  occupation: boolean;
  secondSurname: boolean;
  documentTypeAndNumber: boolean;
  gender: boolean;
  ageLimit: number | null;
}
export interface IOwnerOrganisation {
  legalEntityId: boolean;
  organisationName: boolean;
  organisationType: boolean;
  departmentName: boolean;
  primaryAddress: boolean;
}

export interface IOwnerResponse {
  legalTypes: IObject;
  individual: {
    legalEntityId: boolean;
    fullName: boolean;
    primaryAddress: boolean;
    dateOfBirth: boolean;
    placeOfBirth: boolean;
    nationality: boolean;
    height: boolean;
    secondSurname: boolean;
    occupation: boolean;
    documentTypeAndNumber: boolean;
    gender: boolean;
    ageLimit: number | null;
  };
  organisation: {
    legalEntityId: boolean;
    organisationName: boolean;
    organisationType: boolean;
    departmentName: boolean;
    primaryAddress: boolean;
  };
}
export interface ILicenceTemplateRequest {
  uniqueId: string;
  general: IGeneralRequest;
  owner: IOwner;
  conditions: IConditionsRequest;
  documentInformation: IDocumentInformation;
  printoutSettings: IPrintoutSettings;
}
export interface ISearchForm {
  name: string;
  code: string;
}

export interface ILicenceTemplateForLe {
  uniqueId: string;
  published: boolean;
  general: {
    name: string;
    description: string;
    code: string;
    licenceDurationYears: number;
    licenceDurationMonths: number;
    licenceDurationDays: number;
    licenceDurationUnlimited: boolean;
  };
  owner: {
    legalTypes: string[];
    individual: {
      legalEntityId: boolean;
      fullName: boolean;
      primaryAddress: boolean;
      dateOfBirth: boolean;
      placeOfBirth: boolean;
      nationality: boolean;
      height: boolean;
      occupation: boolean;
      documentTypeAndNumber: boolean;
      gender: boolean;
      ageLimit: number | null;
    };
    organisation: {
      legalEntityId: boolean;
      organisationName: boolean;
      organisationType: boolean;
      departmentName: boolean;
      primaryAddress: boolean;
    };
  };
  parameters: {
    code: string;
    licenceDurationYears: number;
    licenceDurationMonths: number;
    licenceDurationDays: number;
    licenceDurationUnlimited: boolean;
  };
  conditions: {
    goodReason: string;
    goodReasonDictionaryIds: string[];
    specificCountryArea: boolean;
    competency: boolean;
    safeStorage: string;
    weaponCategory: boolean;
    weaponNumberLimit: boolean;
    carryConditions: boolean;
    additionalConditions: boolean;
  };
  documentInformation: {
    licenceName: boolean;
    licenceNumber: boolean;
    validityPeriod: boolean;
    licenceCategory: boolean;
    carryConditions: boolean;
    region: boolean;
    goodReason: boolean;
    competency: boolean;
    weaponNumberLimit: boolean;
    licencingAuthority: boolean;
    licencingAuthoritySignature: boolean;
    additionalConditions: boolean;
    legalEntityIndividualId: boolean;
    legalEntityOrganisationId: boolean;
    organisationPrimaryAddress: boolean;
    individualPrimaryAddress: boolean;
    organisationName: boolean;
    organisationType: boolean;
    departmentName: boolean;
    fullName: boolean;
    dateOfBirth: boolean;
    placeOfBirth: boolean;
    nationality: boolean;
    gender: boolean;
    photo: boolean;
    height: boolean;
    occupation: boolean;
    urn: boolean;
    type: boolean;
    make: boolean;
    model: boolean;
    calibre: boolean;
    serialNumber: boolean;
    weaponCategory: boolean;
    action: boolean;
  };
  printoutSettings: IPrintoutSettings;
  prices: ILicenceTemplateApplicationProcessResponse[];
  version: number;
  createdDate: string;
}

export interface ILicenceTemplateApplicationProcessForm {
  licenceTemplateUniqueId: string;
  priceName: string;
  priceFee: string;
  processTypeUniqueId: string;
  priceDescription: string;
  legalEntityType: LETypes | null;
  comment: string;
}
export interface ILicenceTemplateApplicationProcessPriceForm {
  licenceTemplateUniqueId: string;
  priceName: string;
  priceFee: string;
  priceDescription: string;
}
export interface ILicenceTemplateApplicationProcessSettingsForm {
  licenceTemplateUniqueId: string;
  processTypeUniqueId: string;
  processType: EProcessTypes | null;
  legalEntityType: LETypes | null;
  comment: string;
}
export interface ILicenceTemplateApplicationProcess {
  licenceTemplateUniqueId: string;
  priceName: string;
  priceFee: string;
  processTypeUniqueId: string;
  priceDescription: string;
  legalEntityType: LETypes;
  comment: string;
}
export interface ILicenceTemplateApplicationProcessPriceUpdate {
  priceName: string;
  priceFee: string;
  priceDescription: string;
  version: string;
}
export interface ILicenceTemplateApplicationProcessSettingsUpdate {
  legalEntityType: LETypes;
  comment: string;
  version: string;
}

export interface ILicenceTemplateApplicationProcessTaskForm {
  nameUniqueId: string;
  description: string;
}
export interface ILicenceTemplateApplicationProcessTaskRequest {
  applicationProcessId: string;
  nameUniqueId: string;
  description: string;
}
export interface ILicenceTemplateApplicationProcessTask {
  uniqueId: string;
  nameUniqueId: string;
  description: string;
}
export interface ILicenceTemplateApplicationProcessTasksResponse extends IPaginator {
  content: ILicenceTemplateApplicationProcessTask[];
}

export interface ILicenceTemplatesForLe extends IPaginator {
  content: ILicenceTemplateForLe[];
}

export interface ILicenceTemplateApplicationProcessDocumentForm {
  typeUniqueId: string;
  importantNotice: string;
}
export interface ILicenceTemplateApplicationProcessDocumentRequest {
  applicationProcessId: string;
  typeUniqueId: string;
  importantNotice: string;
}
export interface ILicenceTemplateApplicationProcessDocument {
  uniqueId: string;
  typeUniqueId: string;
  importantNotice: string;
}
export interface ILicenceTemplateApplicationProcessDocumentsResponse extends IPaginator {
  content: ILicenceTemplateApplicationProcessDocument[];
}
export interface ILicenceTemplateApplicationProcessIntelligenceReportForm {
  sourceSystemUniqueId: string;
  instructions: string;
}
export interface ILicenceTemplateApplicationProcessIntelligenceReportRequest {
  applicationProcessUniqueId: string;
  sourceSystemUniqueId: string;
  instructions: string;
}
export interface ILicenceTemplateApplicationProcessIntelligenceReport {
  uniqueId: string;
  sourceSystemUniqueId: string;
  instructions: string;
}
export interface ILicenceTemplateApplicationProcessIntelligenceReportsResponse extends IPaginator {
  content: ILicenceTemplateApplicationProcessIntelligenceReport[];
}
export interface ILicenceTemplatePrintoutSettingsAvailableFields {
  general: {
    licenceName: boolean;
    licenceCode: boolean;
    licenceNumber: boolean;
    licencePeriod: boolean;
    issueDate: boolean;
    issuedLicencingAuthorityName: boolean;
    issuedLicencingAuthorityPerson: boolean;
    issuedLicencingAuthoritySignature: boolean;
  };
  conditions: {
    areaRestriction: boolean;
    competency: boolean;
    safeStorage: boolean;
    weaponCategorisation: boolean;
    weaponNumberLimit: boolean;
    carryConditions: boolean;
    statutoryAndAdditionalConditions: boolean;
    goodReasons: boolean;
  };
  owner: {
    legalType: boolean;
    fullName: boolean;
    secondSurname: boolean;
    primaryAddress: boolean;
    gender: boolean;
    documentTypeAndName: boolean;
    dateOfBirth: boolean;
    placeOfBirth: boolean;
    nationality: boolean;
    height: boolean;
    occupation: boolean;
    photo: boolean;
    organisationType: boolean;
    organisationName: boolean;
    departmentName: boolean;
  };
  weaponData: {
    type: boolean;
    make: boolean;
    model: boolean;
    calibre: boolean;
    action: boolean;
    manufacturer: boolean;
    serialNumber: boolean;
  };
}
